import { Link } from 'react-router-dom';
import { ArrowRight, MessageSquare } from 'lucide-react';
import { Button } from '../ui/button';

export const CTAStrip = (props) => {
  const title = props.title || "Ready to modernize certification?";
  const subtitle = props.subtitle || "Join national systems and exporters who trust Certisfy for their phytosanitary compliance.";
  const primaryCTA = props.primaryCTA || "Request a Demo";
  const secondaryCTA = props.secondaryCTA || "Contact Us";
  const primaryLink = props.primaryLink || "/contact?demo=true";
  const secondaryLink = props.secondaryLink || "/contact";
  const variant = props.variant || "green";
  
  const isGreen = variant === "green";

  return (
    <section 
      data-testid="cta-strip"
      className={`section-padding ${isGreen ? 'bg-[#1F7A3A]' : 'bg-white border-t border-b border-slate-200'}`}
    >
      <div className="container-custom">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
          <div className="text-center lg:text-left max-w-2xl">
            <h2 className={`text-3xl lg:text-4xl font-bold mb-4 ${isGreen ? 'text-white' : 'text-slate-900'}`}>
              {title}
            </h2>
            <p className={`text-lg ${isGreen ? 'text-green-100' : 'text-slate-600'}`}>
              {subtitle}
            </p>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4">
            <Link to={primaryLink} data-testid="cta-strip-primary">
              <Button 
                className={`${
                  isGreen 
                    ? 'bg-white text-[#1F7A3A] hover:bg-green-50' 
                    : 'btn-primary'
                } rounded-full px-8 py-3 font-semibold inline-flex items-center gap-2`}
              >
                {primaryCTA}
                <ArrowRight className="w-4 h-4" />
              </Button>
            </Link>
            <Link to={secondaryLink} data-testid="cta-strip-secondary">
              <Button 
                variant="outline"
                className={`${
                  isGreen 
                    ? 'border-white text-white hover:bg-white/10' 
                    : 'btn-secondary'
                } rounded-full px-8 py-3 font-semibold inline-flex items-center gap-2`}
              >
                <MessageSquare className="w-4 h-4" />
                {secondaryCTA}
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
